import React from "react";

// material-ui
import { Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// assets
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";

// ==============================|| HEADER SORT ||============================== //

interface HeaderSortProps {
  column: any;
  sortedAsc?: boolean;
  sordedDesc?: boolean;
}

export const HeaderSort = ({ column, sortedAsc, sordedDesc }: HeaderSortProps) => {
  const theme = useTheme();
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ display: "inline-flex" }}>
      <Box>{column.render("Header")}</Box>
      {!column.disableSortBy && (
        <Stack sx={{ color: "text.secondary" }}>
          <CaretUpOutlined
            style={{
              fontSize: "0.625rem",
              color: sortedAsc ? theme.palette.text.secondary : "inherit",
            }}
          />
          <CaretDownOutlined
            style={{
              fontSize: "0.625rem",
              marginTop: -2,
              color: sordedDesc ? theme.palette.text.secondary : "inherit",
            }}
          />
        </Stack>
      )}
    </Stack>
  );
};
